// App
export const SET_URL = 'SET_URL';
export const INIT_APP = 'INIT_APP';
export const INIT_CONTENT = 'INIT_CONTENT';

// Locations
export const SET_LOCATIONS = 'SET_LOCATIONS';
export const SET_LOCATIONS_CACHE = 'SET_LOCATIONS_CACHE';
export const SET_LOCATION_FILTERS = 'SET_LOCATION_FILTERS';
export const SET_FILTERS_VISIBILITY = 'SET_FILTERS_VISIBILITY';
export const SET_SELECTED_LOCATION = 'SET_SELECTED_LOCATION';
export const SET_INITIAL_LOCATION = 'SET_INITIAL_LOCATION';
export const SET_SELECTED_LOADING = 'SET_SELECTED_LOADING';
export const SET_LOCATION_DETAILS_CACHE = 'SET_LOCATION_DETAILS_CACHE';

// Maps
export const SET_MAP = 'SET_MAP';
export const SET_ZOOM = 'SET_ZOOM';
export const SET_BOUNDS = 'SET_BOUNDS';
export const SET_GEOLOCATION = 'SET_GEOLOCATION';
export const SET_PLATFORM = 'SET_PLATFORM';

// Search
export const SET_SEARCH_QUERY = 'SET_SEARCH_QUERY';
export const SET_SELECTED_RESULT = 'SET_SELECTED_RESULT';
export const SET_SELECTED_INPUT = 'SET_SELECTED_INPUT';
export const SET_AUTOCOMPLETE_RESULTS = 'SET_AUTOCOMPLETE_RESULTS';

// Service
export const SET_SERVICE_ACTIVE = 'SET_SERVICE_ACTIVE';
export const SET_SERVICE_AVAILABLE = 'SET_SERVICE_AVAILABLE';
export const SET_SERVICE_COUNTRY = 'SET_SERVICE_COUNTRY';
